module.exports = __webpack_public_path__ + "img/ch15.52ebff43.jpg";